import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah M.',
    age: '52',
    text: 'I was skeptical, but after just 24 hours of the tonic, my bloating went down significantly. I finally feel comfortable in my clothes again!',
    rating: 5
  }, {
    name: 'Jennifer K.',
    age: '48',
    text: 'The 5-minute ritual is so easy to fit into my morning. My energy levels are stable all day, and no more afternoon crash.',
    rating: 5
  }, {
    name: 'Patricia L.',
    age: '55',
    text: 'Simple, effective, and natural. Exactly what I was looking for. The grocery list made it so easy to get started.',
    rating: 5
  }];
  return <section className="py-20 bg-amber-50" data-id="element-153">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-154">
        <div className="text-center mb-12" data-id="element-155">
          <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-156">
            Join thousands of women who have replaced the "bloat" with "glow"
          </h2>
          <div className="flex justify-center gap-1" data-id="element-157">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-amber-500 fill-current" data-id="element-158" />)}
          </div>
          <p className="text-stone-600 mt-2" data-id="element-159">
            4.9/5 Average Rating from Beta Testers
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-160">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sm border border-amber-100" data-id="element-161">
              <div className="flex gap-1 mb-4" data-id="element-162">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber-400 fill-current" data-id="element-163" />)}
              </div>
              <p className="text-stone-700 mb-6 italic" data-id="element-164">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-165">
                <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center font-bold text-stone-500" data-id="element-166">
                  {t.name[0]}
                </div>
                <div data-id="element-167">
                  <p className="font-bold text-stone-900" data-id="element-168">{t.name}</p>
                  <p className="text-xs text-stone-500" data-id="element-169">Age {t.age}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}